let teleportIdx = 1
const teleportIdList: string[] = []

export const useTeleport = () => {
  const createTeleportEl = () => {
    const el = document.createElement('div')
    const id = `bc-teleport-${teleportIdx++}`
    el.id = id
    document.body.appendChild(el)
    teleportIdList.push(id)
    return id
  }

  const removeTeleportEl = (id: string) => {
    const idx = teleportIdList.indexOf(id)
    document.getElementById(id)?.remove()
    teleportIdList.splice(idx, 1)
  }

  return {
    createTeleportEl,
    removeTeleportEl,
  }
}
